<style src="../vendor/DataTables/DataTables-1.10.20/css/dataTables.bootstrap4.css"></style>
<style src="../vendor/DataTables/DataTables-1.10.20/css/jquery.dataTables.min.css"></style>
<style src="../vendor/DataTables/ColReorder-1.5.2/css/colReorder.dataTables.min.css"></style>

<template>
<div class="bg-white">
  <card class="strpied-tabled-with-hover" body-classes="table-full-width table-responsive">
    <template slot="header">
      <span class="d-flex justify-content-between">
        <span>
          <h4 class="card-title">{{tableCaption}}</h4>
          <p class="card-category">{{tableDescription}}</p>
        </span>
        <span class="mt-3">
          <b-button variant="primary" class="tableButtons" v-on:click="updateData"><i class="fa fa-refresh"></i>Aktualizovat</b-button>
          <b-button v-if="canCreate" variant="success" class="tableButtons" style="width: 100px !important;" :to="formPath"><i class="fa fa-plus"></i>Nový záznam</b-button>
          <b-button v-if="canCreate && canDelete && userPermissionTable" variant="success" class="tableButtons buttonPermission" v-on:click="resetUserPermissions">
            <i class="fa fa-refresh"></i>Resetovat oprávnění
          </b-button>
        </span>
      </span>
      <hr>
    </template>

    <div class="bg-white p-3" style="min-height: 325px !important">
      <table :id="tableId" class="table table-hover nowrap bg-white dataTableStyle display" style="width:100%">
          <thead>
              <tr>
                <th :class="tableId + 'thTag'" v-for="column in columns" :key="column.name" scope="col" :id="tableId + column.name" :style="column.style">
                  {{column.caption}}
                </th>
              </tr>
          </thead>
          <tbody></tbody>
      </table>
    </div>
  </card>
</div>
</template>

<script>
  import dataTableUtils from '@/js/DataTableUtils.js';
  import JQuery from 'jquery';
  import '@/vendor/DataTables/DataTables-1.10.20/js/jquery.dataTables.min.js';
  import '@/vendor/DataTables/ColReorder-1.5.2/js/dataTables.colReorder.min.js';
  import dataService from '@/services/dataService.js';

  let $ = JQuery

  export default {
    name: "GeneralDatatables",
    props: {
      tableId: {
        type: String
      },
      columns: {
        type: Array,
        default: () => []
      },
      data: {},
      pageLength: {
        type: Number,
        default: 15
      },
      tableCaption: String,
      tableDescription: String,
      formPath: String,
      getDataFunction: Function,
      tableType: null,
      canCreate: {
        type: Boolean,
        default: true
      },
      canDelete: {
        type: Boolean,
        default: true
      },
      userPermissionTable: {
        type: Boolean,
        default: false
      },
      columnDefinitions: {
        type: Array,
        default: () => []
      },
    },
    methods: {
      /**
       * Update data in the table manually
       */
      async updateData() {
        let datatable = $('#' + this.tableId).DataTable();
        datatable.clear();
        datatable.rows.add(await this.getDataFunction());
        datatable.draw(false);
      },
      /**
       * Create the click event manually
       */
      createOnClickEvents () {
        let realThis = this;

        if (this.canDelete) {
          $('#' + this.tableId).on('click', '.datatablesBtnDelete', async function () {
            if (realThis.tableType == null) {
              throw 'Unknow table type';
            }
            let tr = $(this).closest('tr');
            let row = $('#' + realThis.tableId).DataTable().row(tr);
            let id = row.data().Id;

            if (realThis.userPermissionTable)
              await dataService.deactiveUserPermission(id);
            else
              await dataService.dataDeleteById(id, realThis.tableType);

            await realThis.updateData();
          });
        }

        if (this.canCreate) {
          $('#' + this.tableId).on('click', '.datatablesBtnEdit', async function () {
            var data = $('#' + realThis.tableId).DataTable().row( $(this).parents('tr') ).data();
            realThis.$router.push({path: realThis.formPath, query: { objectData: JSON.parse(JSON.stringify(data)), newForm: false }});
          });
        }
      },
      async resetUserPermissions() {
        await dataService.resetUserPermissions();
        await this.updateData();
      }
    },
    mounted: async function () {
      this.createOnClickEvents();

      if ((this.canCreate) && (this.formPath !== null) && this.columns.map(function(e) { return e.name; }).indexOf(this.tableId + 'Edit') === -1) {
        this.columns.push({
          name: this.tableId + 'Edit',
          caption: 'Edit',
          render: function (data, type, row) {
            return '<b-button class="btn btn-primary btn-sm datatablesBtnEdit"><i class="fa fa-pencil"></i></b-button>';
          },
          style: 'width: 40px;'
        });
      }

      if ((this.canDelete) && (this.columns.map(function(e) { return e.name; }).indexOf(this.tableId + 'Delete') === -1)) {
        this.columns.push({
          name: this.tableId + 'Delete',
          caption: 'Smazat',
          render: function (data, type, row) {
            return '<b-button class="btn btn-danger btn-sm datatablesBtnDelete"><i class="fa fa-remove"></i></b-button>'
          },
          style: 'width: 40px;'
        }); 
      }

      // Generate columns
      this.columns.forEach(column => {
        if (column.checkbox) {
          column.render = function (data, type, row) {
            let checked = '';
            if (data)
              checked = 'checked';
            return '<input class="align-middle ml-3" type="checkbox" id="' + data + 'CHB" v-model="true" ' + checked + ' onclick="return false;">'
          },
          column.style = 'width: 70px;'
        }

        if (column.dateFormat) {
          column.render = function (data, type, row) {
            return dataTableUtils.renderDate(data);
          }
        }

        if (column.isList) {
          column.render = function (data, type, row) {
            let result = [];
            data.forEach(element => {
              let listEl = element;
              column.listColumn.forEach(listColumnElement => {
                listEl = listEl[listColumnElement];
              });

              result.push(listEl);
            });

            return result.join(', ');
          }
        }

        this.columnDefinitions.push({name: this.tableId + column.name, data: column.name, render: column.render, width: column.width});
      });

      // Array of random values
      var settings = {
          "processing": true,
          "serverSide": false,
          "filter": false,
          "searching": true,
          "columns": this.columnDefinitions,
          "aaData": this.data,
          "autoWidth": false,
          pageLength: this.pageLength,
          scrollCollapse: true,
          colReorder: true
      };

      dataTableUtils.localize(settings, 'cs');
      var table = $("#" + this.tableId).DataTable(settings);
     
      $('#' + this.tableId + '_filter input').addClass('form-control');
      $('#' + this.tableId + '_length select').addClass('form-control mx-2');
    }
  }
</script>

<style>
.dataTableStyle th {
    color: white;
    overflow: hidden;
    text-overflow: ellipsis;
    overflow-wrap: unset;
}

.percentColumn {
    width: 40px;
    min-width: 40px;
    max-width: 40px;
}

td.details-control {
  background-color: white !important;
  cursor: pointer;
  color: gray;
}

td.details-control:before {
  font-family: "FontAwesome";
  content: "\f078";
}

td.details-control:hover {
  color: black;
}

.tableButtons {
  margin-right: 5px !important;
  font-size: 11px !important;
  padding: 4px !important;
  width: 100px !important;
}

.buttonPermission {
  width: 150px !important;
}
</style>